import PhotoSelector from './PhotoSelector';

export default PhotoSelector;
